// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3lvnm","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1IOm5"};